import type { $Enums } from '@prisma/client'


import { useState } from 'react';
interface EditAudioModalData {
  musicModel: Extract<$Enums.MusicModel, 'V2' | 'V3'>
  musicType: $Enums.MusicType
  token?: string
  filename: string
  file: string
  beginTime?: number
  endTime?: number
  onSuccess?: (props: Pick<EditAudioModalData, 'token' | 'filename'>) => void
}
export function useEditAudioModal() {
  const [open, setOpen] = useState(false)
  const [data, setData] = useState<EditAudioModalData>({
    musicModel: 'V3',
    musicType: 'Song',
    token: '',
    filename: '',
    file: '',
  })

  const show = (data: EditAudioModalData) => {
    setData(data)
    setOpen(true)
  }

  const close = () => {
    setOpen(false)
  }

  return {
    open,
    show,
    close,
    data,
  }
}
